module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.23.0@babel-runtime/core-js/object/assign.js
// module id = 30
// module chunks = 0